// ============================================================
// SINGLE SOURCE OF TRUTH FOR SITE CONFIG & CANONICAL URL
// Switch `canonicalBase` to the live domain when connected.
// ============================================================
export const SITE = {
    // Canonical / domain — change ONLY this line when the domain goes live.
    canonicalBase: "https://createwithnikhil.com",

    name: "Nikhil Joshi",
    handle: "createwithnikhil",
    title: "Nikhil Joshi | AI Visual Creator & Video Editor — createwithnikhil",
    description:
        "Nikhil Joshi — AI Visual Creator & Video Editor. Cinematic AI visuals for brands including LOTTO Sport US, SPARX, Cherrapunji Gin, Maggi and Tanishq. Based in New Delhi.",
    positioning:
        "AI Visual Creator & Video Editor — cinematic, luxury-grade AI visuals for brands.",

    email: "createwithnikhiljoshi@gmail.com",
    phone: "+91 96431 82454",
    phoneHref: "tel:+919643182454",
    whatsapp:
        "https://wa.me/919643182454?text=" +
        encodeURIComponent("Hi Nikhil, I saw your portfolio and would like to discuss a project."),
    formEndpoint:
        "https://script.google.com/macros/s/AKfycbwLce1Yk7JYyIA86q9vw1fkXNGvL62_wVTckIa37Nk5nKrogcae1SiS_NY9jyxS4W5m/exec",
    instagram: "https://www.instagram.com/createwithnikhil/",
    instagramHandle: "@createwithnikhil",
    linkedin: "https://www.linkedin.com/in/thenikhiljoshi/",

    locality: "New Delhi",
    region: "Delhi",
    country: "India",

    ogImage: "/og-image.jpg", // 1200x630 — upload your own hero image here.
};
